import { render } from "./Spectrum.vue?vue&type=template&id=4950f760&scoped=true"
import script from "./Spectrum.vue?vue&type=script&lang=js"
export * from "./Spectrum.vue?vue&type=script&lang=js"

import "./Spectrum.vue?vue&type=style&index=0&id=4950f760&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4950f760"]])

export default __exports__